import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Szablon kontraktu',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Podgląd',
  },
  sections: {
    subscription: 'Subskrypcja',
    setup_cost: 'Koszt konfiguracji',
    preview: 'Podgląd',
  },
  form: {
    has_trial: {
      label: 'Dodaj dni próbne',
    },
    trial_days: {
      label: 'Bezpłatne dni próbne',
      placeholder: '7',
      validation: {
        required: 'Liczba dni próbnych jest wymagana',
        min: '{{value}} to minimalna wartość dla dni próbnych',
      },
    },
  },
  buttons: {
    apply: 'Zastosuj zmiany',
    download: 'Pobierz',
    apply_changes: 'Zastosuj zmiany',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się wczytać podglądu',
  },
};
